import {
  PERFORMANCE_EXPECTATION_CCC,
  PERFORMANCE_EXPECTATION_DCI,
  PERFORMANCE_EXPECTATION_ENG,
  PERFORMANCE_EXPECTATION_NOS,
  PERFORMANCE_EXPECTATION_SEP,
} from 'global/constants';
import {
  OutcomeOption,
  OptionWithKey,
} from './tag-autocomplete-outcomes.constants';

export function doValidateInput(
  currentValues: OutcomeOption[] | undefined,
  values: string[],
  options: OutcomeOption[],
  allOtherOptions: OptionWithKey[]
) {
  return values.reduce(
    (accum, curr) => {
      const current = curr.toUpperCase();
      const otherOption = allOtherOptions.find(option =>
        option.label.toUpperCase().startsWith(current)
      );

      const validOptionToAdd =
        options &&
        options.find(option => option.label.toUpperCase().startsWith(current));

      const duplicateOption =
        currentValues &&
        currentValues.find(option =>
          option.label.toUpperCase().startsWith(current)
        );

      if (otherOption && !otherOption.alreadyAdded) {
        accum.otherOptions.push(otherOption);
      } else if ((otherOption && otherOption.alreadyAdded) || duplicateOption) {
        accum.alreadyAdded.push(
          (otherOption && otherOption.label) ||
            (duplicateOption && duplicateOption.label) ||
            curr
        );
      } else if (validOptionToAdd) {
        accum.valid.push(validOptionToAdd);
      } else {
        accum.invalid.push(curr);
      }

      return accum;
    },
    {
      valid: [],
      invalid: [],
      alreadyAdded: [],
      otherOptions: [],
    } as {
      valid: OutcomeOption[];
      invalid: string[];
      alreadyAdded: string[];
      otherOptions: OptionWithKey[];
    }
  );
}

export function isToBeFilteredOnName(outcomeOption: OutcomeOption | undefined) {
  return outcomeOption
    ? [
        PERFORMANCE_EXPECTATION_SEP,
        PERFORMANCE_EXPECTATION_CCC,
        PERFORMANCE_EXPECTATION_ENG,
        PERFORMANCE_EXPECTATION_NOS,
        PERFORMANCE_EXPECTATION_DCI,
      ].includes(outcomeOption.category || '')
    : false;
}

export function filterInput(
  input: string,
  candidate: {
    label: string;
    data: OutcomeOption;
  }
): boolean {
  if (input) {
    const lowerCaseInput = input.toLowerCase();
    const name =
      (candidate.data.name && candidate.data?.name.toLowerCase()) || '';
    const nameCode =
      (candidate.data.nameCode && candidate.data.nameCode.toLowerCase()) || '';
    const label = candidate.data.label.toLowerCase();
    return (
      name.indexOf(lowerCaseInput) > -1 ||
      nameCode.indexOf(lowerCaseInput) > -1 ||
      label.indexOf(lowerCaseInput) > -1
    );
  }
  return true;
}
